
import { mapState, mapActions, mapGetters } from 'vuex';
import TextInput from '@/mixins/TextInput';

export default {
  name: 'AppCommentInput',
  mixins: [TextInput],
  props: {
    reviewId: {
      type: Number,
      required: true
    },
    commentId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      isInputFocused: false
    };
  },
  computed: {
    ...mapState('widget', ['widget']),
    ...mapState('comment', ['isLoadingComments']),
    ...mapState('window', ['windowService']),
    ...mapGetters('widget', ['device']),
    ...mapGetters('session', ['isLoggedIn']),
    isSubmitForEdit() {
      return !!this.commentId;
    }
  },
  watch: {
    currentValue() {
      this.calcTextareaHeight();
    }
  },
  mounted() {
    setTimeout(() => {
      this.calcTextareaHeight();
    });
    if (this.isSubmitForEdit) this.$refs.textarea.focus();
  },
  methods: {
    ...mapActions('comment', ['createComment', 'updateComment']),
    ...mapActions('widget', ['confirmForLogin']),
    onChangeInput() {
      this.change(this.$refs.textarea.value);
    },
    onClickCancel() {
      this.isSubmitForEdit ? this.cancelEdit() : this.cancelCreate();
    },
    onClickSubmitComment() {
      this.isSubmitForEdit ? this.submitEdit() : this.submitCreate();
    },
    cancelCreate() {
      this.change(null);
      this.isInputFocused = false;
    },
    cancelEdit() {
      this.windowService
        .confirm(this.$t('confirm_cancel_edit'))
        .then(response => {
          if (response) {
            this.change(null);
            this.isInputFocused = false;
            this.$emit('edit-done');
          }
        });
    },
    submitCreate() {
      this.createComment({
        reviewId: this.reviewId,
        message: this.currentValue
      }).catch(() =>
        this.windowService.alert(this.$t('create_comment_failure'))
      );
      this.change(null);
    },
    submitEdit() {
      this.updateComment({
        reviewId: this.reviewId,
        commentId: this.commentId,
        message: this.currentValue
      })
        .then(() => {
          this.change(null);
          this.$emit('edit-done');
        })
        .catch(() => this.windowService.alert(this.$t('edit_comment_failure')));
    },
    onFocusInput() {
      if (this.isLoggedIn) {
        this.isInputFocused = true;
        return;
      }
      this.$refs.textarea.blur();
      this.confirmForLogin();
    },
    calcTextareaHeight() {
      const textarea = this.$refs.textarea;
      if (!this.currentValue?.length) {
        textarea.style.height = this.device === 'mobile' ? '40px' : '44px';
        return;
      }

      textarea.style.height = 'auto';
      const additionalHeightForNotShowingScrollbar = 2;
      const scrollHeight =
        textarea.scrollHeight + additionalHeightForNotShowingScrollbar;
      textarea.style.height = `${scrollHeight}px`;
    }
  }
};
